import { InjectionToken } from '@angular/core';

export const MODULE_CONTEXT = new InjectionToken<string>('MODULE_CONTEXT');